// dbext:profile=staging_mcdo2019_be
import $        from "jquery";
import Sortable from "sortablejs";

import admin_general      from "./905-admin_general.js";
import admin_crud         from "./910-admin_crud.js";
import admin_upload_image from "./911-admin_upload_image.js";
import admin_tinymce      from "./914-admin_tinymce.js";

export default {

    init()
    {
        // categories overview?
        if ( $('.c-admin-categories' ).length > 0 ){
            this.init_categories();
        }
        // category page?
        else if ( $('.c-admin-category' ).length > 0 ){
            this.init_category();
        }
    },

    // ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  CATEGORIES  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_categories()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // make categories sortable
        new Sortable( $('.js-categories--sortable')[0], {
            animation : 100,
            onUpdate  : this.on__sort_categories__update(),
        } );
    },

    on__sort_categories__update()
    {
        return async( e ) => {

            // dom elements
            let de_sorted_item = $(e.item);

            // category ids
            let category_ids = [];

            $('.js-categories').find('li').each(( i, de_category ) => {
                de_category = $(de_category);
                category_ids.push( de_category.data('category_id') );
            });

            var weight = 10;
            for ( let id of category_ids ){

                let response = await
                admin_crud.POST( admin_crud.posturl( '130_category', 'update' ), {
                    ids  : {
                            'id' : id ,
                           },
                    data:  {
                            'weight' : weight,
                           },
                } );

                weight += 10;
            }
        };
    },

    //⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  CATEGORY  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_category()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // event handlers
        $('.js-form'         ).on( 'submit', this.on__form__submit()         );
        $('.js-delete-button').on( 'click' , this.on__delete_button__click() );
        $('.js-tab__delete'  ).on( 'click' , this.on__delete_tab__click()    );

        // slugification
        $('[name="name_en"]').on( 'blur', this.on__name__blur() );
        $('[name="name_nl"]').on( 'blur', this.on__name__blur() );
        $('[name="name_fr"]').on( 'blur', this.on__name__blur() );

        // initialize the image upload
        let image_upload = new admin_upload_image();
        image_upload.init( {
            wrapper_class : '.js-image-upload',
            post_url      : '/admin/upload/category-image',
        } );

        // reset all checkboxes (they get checked later)
        $('.js-category__checkbox').prop( 'checked', false );

        // insert mode?
        if ( g_mode === 'insert' ){

            // published default on
            $('input[name="published"]').prop( 'checked', true );
        }

        // update mode? ⇒ make frontend reflect g_category
        if ( g_mode === 'update' ){

            for ( let [ key, value ] of Object.entries( g_category ) ){

                // empty value? ⇒ do nothing
                if ( value === null ){
                    continue;
                }

                // image
                if ( key === 'image' && value ){
                    image_upload.set_image( value );
                    continue;
                }

                // we need strings from now on
                if ( typeof value !== 'string' ){
                    continue;
                }

                // get the DOM element
                let de = $('[name="' + key + '"]');
                if ( de.length === 0 ){
                    continue;
                }

                // input type checkbox
                if ( de.attr('type') === 'checkbox' ){
                    de.prop( 'checked', ( value == 1 ) );
                    continue;
                }

                // input type text
                if ( de.attr('type') === 'text' ){
                    de.val( value );
                    continue;
                }

            }
        }

        admin_tinymce.init();
    },

    on__form__submit()
    {
        return async ( e ) => {

            e.preventDefault();

            admin_general.start_spinning();

            // delete button clicked? ⇒ handle separately
            if ( $('.js-delete-button').data( 'delete-button-clicked' ) ){
                $('.js-delete-button').removeData( 'delete-button-clicked' );
                return this.on__form_delete__submit();
            }

            { // collect form data
                var category_data = {};

                // get form data
                let form_data = $('.js-form').serializeArray();

                // form data → data structures
                for ( let { name, value } of form_data ){

                    // TinyMCE? ⇒ retreive value with tinymce.get()
                    if (   name == 'intro_en'
                        || name == 'intro_nl'
                        || name == 'intro_fr'
                       ){
                           var id_intro = 'i-' + name ;
                           category_data[ name ] = admin_tinymce.get_content( id_intro );
                           continue;
                   }

                    category_data[ name ] = value;
                }
            }

            // published: checkbox not set? ⇒ serialize explicitely
            if ( ! category_data['published'] ){
                category_data['published'] = 0;
            }

            // validate_input
            let validated = this.validate_input( category_data );
            if ( ! validated ){

                // show errors
                $('.c-saved.c-saved--errors').show();
                $('.c-saved.c-saved--errors').fadeOut( 2000 );

                admin_general.stop_spinning();

                return;
            }

            // this will contain category-id later
            let category_id = false;

            // insert? ⇒ insert category data in database and get the category_id
            if ( g_mode === 'insert' ){

                // insert category datacfr. 910-admin-crud.js
                let response = await
                admin_crud.POST( admin_crud.posturl( '130_category', 'insert' ), {
                    data : category_data,
                } );

                category_id = response.data.id;
            }

            // update? ⇒ update category data in database
            if ( g_mode === 'update' ){

                // get category-id from g_category
                category_id = g_category.id

                let ids = {
                    'id': category_id,
                };

                let response = await
                admin_crud.POST( admin_crud.posturl( '130_category', 'update' ), {
                    ids  : {
                            'id': category_id,
                           },
                    data : category_data,
                } );

            }

            { // handle redirect/reload

                if ( g_mode === 'insert' ){

                    let target_url = '/admin/category/' + category_id;

                    // redirect to the edit page of the new category
                    window.location.replace( target_url );
                }
                else if ( g_mode === 'update' ){

                    // show category saved
                    $('.c-saved.c-saved--ok').show();
                    $('.c-saved.c-saved--ok').fadeOut('slow');
                }
            }

            // it is possible that the slug has changed ⇒ make the link in the "View" tab reflect that change
            if ( g_mode === 'update' ){
                // regenerate view link
                this.regenerate_view_tab_link_after_save();
            }

            admin_general.stop_spinning();

        };
    },

    on__delete_button__click()
    {
        return ( e ) => {
            $('.js-delete-button').data( 'delete-button-clicked', true );
        };
    },

    on__delete_tab__click()
    {
        return ( e ) => {
            e.preventDefault();

            // fake that somebody clicked on the delete button on the bottom of the page
            $('.js-delete-button').click();
        };
    },

    async on__form_delete__submit()
    {
        { // do we have products in this category? ⇒ don't delete
            var response = await
            admin_crud.GET( admin_crud.posturl( '131_product_category', 'select_where' ), {
                'where' : {
                    'category_id': g_category.id,
                }
            } );

            // check that we have a sane response
            if (
                   response.status != 200
                || ! response.data
                || ! Array.isArray( response.data )
               ){
                alert('Fatal error');
                return;
            }

            // category still contains products? ⇒ bail out
            if( response.data.length > 0 ){
                admin_general.stop_spinning();
                alert( 'This category still contains products. Please unlink those first from this category.' );
                return;
            }
        }

        // are your sure?
        if ( ! confirm( 'Are you sure?' ) ){
            admin_general.stop_spinning();
            return; // user is not sure...
        }

        // delete category record
        var response = await
        admin_crud.POST( admin_crud.posturl( '130_category', 'delete' ), {
            ids : {
                id : g_category.id,
            },
        } );

        // redirect to categories overview
        window.location.replace( '/admin/categories' );

        return;
    },

    validate_input( category_data )
    {
        $('.is-error').removeClass( 'is-error' );

        let validated = true;

        for ( let key of [ 'name_en', 'name_nl', 'name_fr',  ] ){
            if ( ! category_data[key] ){
                validated = false;
                $('[name="'+key+'"]').addClass( 'is-error' );
            }
        }

        for ( let key of [ 'slug_en', 'slug_nl', 'slug_fr', ] ){
            if ( ! category_data[key] ){
                validated = false;
                $('[name="'+key+'"]').addClass( 'is-error' );
                continue;
            }

            if ( ! category_data[key].match( /^[a-z0-9-]+$/ ) ){
                validated = false;
                $('[name="'+key+'"]').addClass( 'is-error' );
                continue;
            }
        }

        return validated;
    },

    on__name__blur()
    {
        return ( e ) => {
            var de_name = $(e.currentTarget);

            this.set_corresponding_slug( de_name );
        };
    },

    set_corresponding_slug( de_name )
    {
        let name = de_name.attr( 'name' );

        let input_slug_name = name.replace( 'name_', 'slug_' );
        let de_slug = $('input[name="'+input_slug_name+'"]');
        if ( de_slug.length === 0 ){
            return;
        }

        // slug already set? ⇒ don't interfere
        if ( de_slug.val() ){
            return;
        }

        // slugify the value
        let slug = admin_general.slugify( de_name.val() );

        de_slug.val( slug );

        admin_general.flash_background( de_slug );
    },

    regenerate_view_tab_link_after_save()
    {
        // compose the link
        let lg = g_language;
        let link = '';
        switch (lg) {
            case 'en': link = '/en/our-menu/'   + $(`input[name="slug_${lg}"]`).val() ; break;
            case 'nl': link = '/nl/ons-menu/'   + $(`input[name="slug_${lg}"]`).val() ; break;
            case 'fr': link = '/fr/notre-menu/' + $(`input[name="slug_${lg}"]`).val() ; break;
        }

        // set the link in the "View" tab
        $('.js-tab__view a').attr( 'href', link );
    },

}

